package org.hs_soft.runmynesto.pages.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.util.Res

@Composable
fun PaintIcon(
    modifier: Modifier=Modifier,
    selectedColor:String?,
    onPaintIconClick:()->Unit,
)
{
    Box(
        modifier = modifier
    )
    {
        CustomIcon(
            modifier = Modifier ,
            iconColor = Theme.ActionActive.hex,
            icon = Res.PathIcon.paintIcon,
            onIconClick = {

            },
        )
        CustomIcon(
            modifier = Modifier ,
            iconColor =  if (selectedColor== Theme.Transparent.hex || selectedColor==null)
                Theme.ActionActive.hex else selectedColor,
            icon = Res.PathIcon.paintLine,
            onIconClick = {
                onPaintIconClick()
            },
        )
    }
}